import { PlayerContextState } from "../../PlayerContext";
import { getRandomUnlockableSecret, SecretType } from "../../secrets/Secrets";
import { SpellActionBase } from "../Spell";

class DivineStoryline extends SpellActionBase {
  getSpellName(): string {
    return "Divine Storyline";
  }

  getArea(): string {
    return "Campus";
  }

  getDisplayDescription(): string {
    return "Attempt to divine how to trigger a Storyline.";
  }

  getDisplayEffect(): string {
    return "Unlocks information about a Storyline. You can view this information in the stats screen.";
  }

  getManaCost(): number {
    return 6000;
  }

  getBaseCooldown(): number {
    // 16 hours
    return 60 * 60 * 16;
  }

  getSchoolLevelRequirements(): Record<string, number> {
    return {
      Divination: 20,
    };
  }

  isEnabled(state: PlayerContextState): boolean {
    return (
      super.isEnabled(state) &&
      getRandomUnlockableSecret(state, SecretType.Storyline) != null
    );
  }

  doSpellAction(state: PlayerContextState): PlayerContextState {
    const secret = getRandomUnlockableSecret(state, SecretType.Storyline);
    return secret?.unlock(state) ?? state;
  }
}

export default new DivineStoryline();
